import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import TableActionButtons from "./tableComponent/TableActionButtons";

const LabelTextComponent = ({
  label,
  text,
  flex = 1,
  edit = false,
  backgroundColor = false,
  handleEdit = () => {},
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <Box
      sx={{
        flex,
        backgroundColor: backgroundColor
          ? "rgba(243, 248, 255, 0.8)"
          : "transparent",
        padding: backgroundColor ? (isMobile ? "8px" : "10px") : 0,
        borderRadius: backgroundColor ? "8px" : 0,
        minWidth: 0, // Ensures the box doesn't grow too wide for its container
      }}
    >
      <Stack>
        <Typography
          fontSize={isMobile ? 10 : 12}
          color="primary"
          sx={{ opacity: 0.75 }}
        >
          {label ?? "Label"}
        </Typography>
        <Stack direction="row" alignItems="center">
          <Typography
            fontSize={isMobile ? 12 : 14}
            fontWeight={500}
            color="primary"
            sx={{ overflowWrap: "anywhere" }}
          >
            {text && text !== "undefined" && text !== undefined
              ? String(text).replace(/undefined/g, "")
              : "--"}
          </Typography>
          {edit && (
            <TableActionButtons handleEdit={handleEdit} showEdit={edit} />
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default LabelTextComponent;
